import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideBarComponent } from './components/side-bar/side-bar.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { RouterModule } from '@angular/router';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { CompanyApprovalPopupComponent } from './components/company-approval-popup/company-approval-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { I18nModule } from '../i18n/i18n.module';
import { ViewMoreComponent } from './components/view-more/view-more.component';
import { MapViewComponent } from './components/map-view/map-view.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { MatMenuModule } from '@angular/material/menu';
import { TelInputComponent } from './tel-input/tel-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LacMatTelInputModule } from 'lac-mat-tel-input';
import { MatselectWithsearchComponent } from './matselect-withsearch/matselect-withsearch.component';
import { MatSelectModule } from '@angular/material/select';
import { EpochToDatePipe } from './epoch-to-date/epoch-to-date.pipe';
import { LiveStatusComponent } from './components/live-status/live-status.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NightingaleChartComponent } from './components/nightingale-chart/nightingale-chart.component';
import { DualChartComponent } from './components/dual-chart/dual-chart.component';
import { BarLineChartComponent } from './components/bar-line-chart/bar-line-chart.component';
import { ServiceTrendComponent } from './components/service-trend/service-trend.component';
import { ErrorOverlayComponent } from './components/error-overlay/error-overlay.component';
import { DualBarChartComponent } from './components/dual-bar-chart/dual-bar-chart.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    SideBarComponent,
    NavBarComponent,
    ConfirmationPopupComponent,
    CompanyApprovalPopupComponent,
    ViewMoreComponent,
    MapViewComponent,
    SnackbarComponent,
    TelInputComponent,
    MatselectWithsearchComponent,
    EpochToDatePipe,
    LiveStatusComponent,
    NightingaleChartComponent,
    DualChartComponent,
    BarLineChartComponent,
    ServiceTrendComponent,
    ErrorOverlayComponent,
    DualBarChartComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    I18nModule,
    GoogleMapsModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    LacMatTelInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatSlideToggleModule,
  ],
  exports: [
    SideBarComponent,
    NavBarComponent,
    ConfirmationPopupComponent,
    MapViewComponent,
    NightingaleChartComponent,
    DualChartComponent,
    ServiceTrendComponent,
    TelInputComponent,
    MatselectWithsearchComponent,
    EpochToDatePipe,
    LiveStatusComponent,
    BarLineChartComponent,
    ErrorOverlayComponent,
    DualBarChartComponent,
  ],
})
export class SharedModule {}
